// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// export const environment = {
//   production: false,
//   API_END_POINT: 'http://localhost:8082',
//   REPORT_API_END_POINT: 'http://localhost:8084',
//   version: require('../../package.json').version,
//   isMock: false
// };

export const environment = {
  production: true,
  API_END_POINT: '/etas-admin-api',
  REPORT_API_END_POINT: '/etas-admin-api',
  version: require('../../package.json').version,
  isMock: false
};
